import { get_token, get_user_details } from "@/router";
import Swal from 'sweetalert2';
import Loader from "@/components/Loader/LoaderView";
import { get_profile_url } from "@/views/Feed/feed_helper.js";


export default {
  components: {
    Loader
  },
  props: {
    is_public: {
      type: Boolean,
      default: false,
    },
    portal_admin: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isHomePage() {
      return this.$route.name === 'home'; // Assuming your home page route is named 'home'
    },
    isHomeFilter() {
      return this.$route.name === 'organisation';
    }
  },

  mounted() {
    this.user_details = get_user_details();
    this.token_exists = get_token();
    this.user_id = this.get_user_id();
    this.get_portal_access_requested_users();
  },
  watch: {
    '$route.params.portal_id'() {
      this.get_portal_access_requested_users();
    }
  },
  data() {

    return ({
      user_details: {
        "user_role": '',
        "user_id": null,
      },
      requested_users: [],
      token_exists: false,
      loading: true,

    })
  },
  methods: {
    getToken() {
      return get_token();
    },
    get_user_id() {
      const user_id = localStorage.getItem('user_id') || '';
      return user_id;
    },
    get_portal_access_requested_users() {

      this.isLoading = true;
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_portal_access_requested_users/`,
        method: 'GET',
        data: { portal_id: this.$route.params.portal_id },
        headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
        success: (response) => {
          this.requested_users = response.data;

          setTimeout(() => {
            this.loading = false;
          }, 1000);
        },
        complete: () => {
          this.isLoading = false;
        }
      });
    },

    getProfileLink(member) {
      const user = member?.base_profile?.user;
      const role = user?.role?.role; // safely access nested role

      if (!user) return '#'; // fallback if no user object found

      if (role === 'admin') {
        return `/user_profile?user_id=${user.id}`;
      } else if (role === 'user') {
        return get_profile_url(user);
      } else {
        return `/user_profile?user_id=${user.id}`;
      }
    },


    approve_portal_access_request(base_profile_id) {
      const baseUrl = `${window.location.origin}${this.$route.path}`
      this.isLoading = true;
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/approve_portal_access_request/`,
        method: 'POST',
        headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
        data: JSON.stringify({
          user_id: this.user_id,
          base_profile_id: base_profile_id,
          portal_id: this.$route.params.portal_id,
          base_url: baseUrl
        }),
        success: (data) => {

          if (data.status === "success") {
            Swal.fire({
              icon: 'success',
              title: 'Success',
              text: 'Access request approved successfully.',
              showConfirmButton: false,
              timer: 1000,
              position: 'bottom-end',
              toast: true
            }).then(() => {
              this.$emit("portalAccepted");
              Swal.close()

            });
            this.requested_users = this.requested_users.filter(
              (user) => user.base_profile.id !== base_profile_id
            );

          }
        },
        complete: () => {
          this.isLoading = false;
        }
      });
    },

    reject_portal_access_request(base_profile_id) {
      this.isLoading = true;
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/reject_portal_access_request/`,
        method: 'POST',
        headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
        data: JSON.stringify({
          user_id: this.user_id,
          base_profile_id: base_profile_id,
          portal_id: this.$route.params.portal_id
        }),
        success: (data) => {
          if (data.status === "success") {
            Swal.fire({
              icon: 'success',
              title: 'Success',
              text: 'Access request declined successfully.',
              showConfirmButton: false,
              timer: 1000,
              position: 'bottom-end',
              toast: true
            })

            this.requested_users = this.requested_users.filter(
              (user) => user.base_profile.id !== base_profile_id
            );
          }
        },
        complete: () => {
          this.isLoading = false;
        }
      });
    },


    approve_all_portal_access_requested_users() {
      const PORTAL_ID = this.$route.params.portal_id;
      const baseUrl = `${window.location.origin}${this.$route.path}`
      Swal.fire({
        title: 'Are you sure you want to approve all users?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, Approve all users',
        position: 'bottom-end',
        toast: true
      }).then((result) => {
        if (result.isConfirmed) {

          $.ajax({
            type: 'POST',
            url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/approve_all_portal_access_requested_users/`,
            data: JSON.stringify({
              portal_id: PORTAL_ID, base_url: baseUrl, user_role: this.user_details.user_role
            }),
            headers: {
              'Authorization': `Token ${this.getToken()}`,
              'Content-Type': 'application/json'
            },
            contentType: 'application/json',
            success: (response) => {
              if (response.status === "success") {
                Swal.fire({
                  title: 'Approved!',
                  text: response.data.message,
                  icon: 'success',
                  showConfirmButton: false,
                  timer: 2000,
                  position: 'bottom-end',
                  toast: true
                })

                this.requested_users = [];
              } else {
                Swal.fire({
                  title: 'Failed!',
                  text: response.message || 'An error occurred. Please try again.',
                  icon: 'error',
                  position: 'bottom-end',
                  showConfirmButton: false,
                  timer: 3000,
                  toast: true
                });
              }
            }
          });
        }
      });
    },
    reject_all_portal_access_requested_users() {
      const PORTAL_ID = this.$route.params.portal_id;
      Swal.fire({
        title: 'Are you sure you want to Reject all users?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, Reject all users',
        position: 'bottom-end',
        toast: true
      }).then((result) => {
        if (result.isConfirmed) {
          this.isLoading = true;
          $.ajax({
            type: 'POST',
            url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/reject_all_portal_access_requested_users/`,
            data: JSON.stringify({ portal_id: PORTAL_ID , user_role: this.user_details.user_role}),
            headers: {
              'Authorization': `Token ${this.getToken()}`,
              'Content-Type': 'application/json'
            },
            contentType: 'application/json',
            success: (response) => {
              if (response.status === "success") {
                Swal.fire({
                  title: 'Rejected!',
                  text: response.data.message,
                  icon: 'success',
                  showConfirmButton: false,
                  timer: 2000,
                  position: 'bottom-end',
                  toast: true
                })

                this.requested_users = [];
              } else {
                Swal.fire({
                  title: 'Failed!',
                  text: response.message || 'An error occurred. Please try again.',
                  icon: 'error',
                  position: 'bottom-end',
                  showConfirmButton: false,
                  timer: 3000,
                  toast: true
                });
              }
            }
          });
        }
      });
    },
  }
}
